// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container-desauth .title-delete[data-v-363d5830]{padding:11px 20px 30px 20px;font-family:DINPro-Bold;font-size:22px;font-weight:700;font-stretch:normal;font-style:normal;line-height:normal;letter-spacing:normal;text-align:center;color:#4d4d4d}.container-actions[data-v-363d5830]{padding-bottom:30px}.q-img[data-v-363d5830]{width:35px}", ""]);
// Exports
module.exports = exports;
